import React from "react";
import { OrgSpeedoMeter as SpeedoMeterWebComponent } from "react-library";
import { Link } from "react-router-dom";
import { t, TLang } from "../../../services/locale.service";
import { Routes } from "../../../routes";
import { useRecoilValue } from "recoil";
import { selectedPlotState } from "../../../state/atoms/global.atom";

type Props = {
  highlights: THighlights;
  value: number;
  majorTicks: Array<string>;
  valueStatus: string;
  valueStatusColor?: string;
  unit?: string;
  sensorName?: string;
  speedoMeterSize?: number;
  language?: TLang;
  plotId: string;
  orgId?: string;
  sensor: string;
  isDisease?: boolean;
  isPest?: boolean;
  isApplicable?: boolean;
  pestId?:string;
  diseaseId?:string;
};

export type THighlight = {
  from: number;
  to: number;
  color: string;
};

export type THighlights = Array<THighlight>;
 
const SpeedoMeter: React.FC<Props> = (props) => {
  const selectedPlot = useRecoilValue(selectedPlotState);

  const { plotId, orgId, sensor, ...speedoMeterProps } = props;
  
  const chartUrl = orgId 
    ? Routes.orgPlotChart
      .replace(":orgId", orgId)
      .replace(":plotId", plotId)
      .replace(":sensor", sensor)
    : Routes.plotChart
      .replace(":plotId", plotId)
      .replace(":sensor", sensor);

  const getAdditionalInfo = () => {
    if (
      "soilMoisture1" === sensor && (selectedPlot?.device as { soilMoisture1Depth?: number })?.soilMoisture1Depth
    ) {
      return `${t("depth")}: ${(selectedPlot?.device as { soilMoisture1Depth?: number }).soilMoisture1Depth} ${t(
        "inch"
      )}`;
    }
    if (
      "soilMoisture2" === sensor &&
      (selectedPlot?.device as { soilMoisture2Depth?: number })?.soilMoisture2Depth
    ) {
      return `${t("depth")}: ${(selectedPlot?.device as { soilMoisture2Depth?: number }).soilMoisture2Depth} ${t(
        "inch"
      )}`;
    } else if (
      speedoMeterProps.isApplicable !== undefined &&
      !speedoMeterProps.isApplicable
    ) {
      return t("notApplicable");
    }
    return "";
  };
  
  return (
    <Link
      to={chartUrl}
      state={{
        sensorName: speedoMeterProps.sensorName,
        isDisease: Boolean(speedoMeterProps.isDisease),
        isPest: Boolean(speedoMeterProps.isPest),
        diseasePestid: speedoMeterProps.isDisease
          ? speedoMeterProps.diseaseId
          : speedoMeterProps.pestId,
      }}
      className="text-decoration-none"
    >
      <SpeedoMeterWebComponent
        {...speedoMeterProps}
        additionalInfo={getAdditionalInfo()}
      />
    </Link>
  );
};

export default SpeedoMeter;


//:TODO: this file is working